import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

// Lightweight back button that DOES NOT disturb header layout.
// Absolutely positioned by parent (header should have position:relative if centering is needed).
// Uses existing standard card design tokens instead of inline heavy styles.
const BackToDashboardButton = ({ previousScreen, goTo, label = 'Back', className = '' }) => {
  if (previousScreen !== 'dashboard') return null;
  return (
    <button
      type="button"
      onClick={() => goTo && goTo('dashboard')}
      className={`standard-back-btn ${className}`}
      aria-label="Back"
      style={{ display:'inline-flex', alignItems:'center', gap:6, background:'#fff', border:'1px solid #e0e0e0', borderRadius:8, padding:'6px 10px', boxShadow:'0 2px 6px rgba(0,0,0,0.06)' }}
    >
      <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 14, color:'#111827' }} />
      {label ? <span style={{ fontSize:14 }}>{label}</span> : null}
    </button>
  );
};

export default BackToDashboardButton;